
import React from 'react';
import FiltersSidebar from './FiltersSidebar';
import MobileFiltersCollapsible from './MobileFiltersCollapsible';

interface PractitionersFiltersProps {
  showSidebar: boolean;
  filters: {
    serviceCategories: string[];
    effectiveDomain: string;
    serviceSubcategory: string;
    distance: string;
    date: Date | undefined;
    timeSlot: string;
    sessionType: string;
    showFreeSession: boolean;
    includeThirdPartyRating?: boolean;
  };
  setFilters: (filters: any) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  userLocation: { lat: number; lng: number } | null;
  userAddress: string | null;
  locationError: string | null;
  isGettingLocation: boolean;
  isLoadingAddress: boolean;
  requestLocationAccess: () => void;
  timeSlots: string[];
  isDateDisabled: (date: Date) => boolean;
  handleCategoryChange: (categoryName: string) => void;
  city: string | null;
  state: string | null;
  country: string | null;
  timezoneDisplay: string | null;
  isApproximateLocation?: boolean;
  setManualLocation?: (lat: number, lng: number, address: string) => void;
  isGeolocationPolicyBlocked?: () => boolean;
}

const PractitionersFilters: React.FC<PractitionersFiltersProps> = ({
  showSidebar,
  filters,
  setFilters,
  searchQuery,
  onSearchChange,
  userLocation,
  userAddress,
  locationError,
  isGettingLocation,
  isLoadingAddress,
  requestLocationAccess,
  timeSlots,
  isDateDisabled,
  handleCategoryChange,
  city,
  state,
  country,
  timezoneDisplay,
  isApproximateLocation,
  setManualLocation,
  isGeolocationPolicyBlocked
}) => {
  if (!showSidebar) return null;

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden lg:block w-80 flex-shrink-0 transition-all duration-300">
        <FiltersSidebar
          filters={filters}
          setFilters={setFilters}
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          userLocation={userLocation}
          userAddress={userAddress}
          locationError={locationError}
          isGettingLocation={isGettingLocation}
          isLoadingAddress={isLoadingAddress}
          requestLocationAccess={requestLocationAccess}
          timeSlots={timeSlots}
          isDateDisabled={isDateDisabled}
          handleCategoryChange={handleCategoryChange}
          city={city}
          state={state}
          country={country}
          timezoneDisplay={timezoneDisplay}
          isApproximateLocation={isApproximateLocation}
          setManualLocation={setManualLocation}
          isGeolocationPolicyBlocked={isGeolocationPolicyBlocked}
        />
      </div>

      {/* Mobile Filters */}
      <div className="lg:hidden mb-4">
        <MobileFiltersCollapsible
          filters={filters}
          setFilters={setFilters}
          searchQuery={searchQuery}
          setSearchQuery={onSearchChange}
          userLocation={userLocation}
          userAddress={userAddress}
          locationError={locationError}
          isGettingLocation={isGettingLocation}
          isLoadingAddress={isLoadingAddress}
          requestLocationAccess={requestLocationAccess}
          timeSlots={timeSlots}
          isDateDisabled={isDateDisabled}
          handleCategoryChange={handleCategoryChange}
          city={city}
          state={state}
          country={country}
          timezoneDisplay={timezoneDisplay}
          isApproximateLocation={isApproximateLocation}
        />
      </div>
    </>
  );
};

export default PractitionersFilters;
